<!--公告及新闻稿-->
<template>
  <div>
    <transition name="moveing">
      <navgate-other ref="topTitle" v-show="isShowTopTitle"></navgate-other>
    </transition>
    
    <main class="index_main_content" ref="parentDiv">
      <div class="index_main_body other" ref="topDiv">
        <div class="zcgy_img"><img src="../../../assets/img/joinus/join-banner.jpg"><div class="mask_bg"></div></div>
        <div class="zcgy_word">
          <div class="zcgy_ch">加入我们</div>
          <div class="zcgy_en">Join Us</div>
        </div>
      </div>
      <div class="second_nav_top" v-show="lockSecondTop" >
        <div class="second_nav_list">
          <div div :class="{active_d:(selectedSecond == '工作环境')}" @click="gotoPoint('workspace','工作环境')" >工作环境</div>
          <div :class="{active_d:(selectedSecond == '快乐工作')}" @click="gotoPoint('happyjob','快乐工作')">快乐工作</div>
          <div :class="{active_d:(selectedSecond == '联系我们')}" @click="gotoPoint('conactus','联系我们')">联系我们</div>
          <div :class="{active_d:(selectedSecond == '招聘信息')}" @click="gotoPoint('recruit','招聘信息')">招聘信息</div>
        </div>
      </div>
      <!--二级导航-->
      <div class="second_nav" ref="secondNav">
        <div class="second_nav_list">
          <div :class="{active_d:(selectedSecond == '工作环境')}" @click="gotoPoint('workspace','工作环境')" >工作环境</div>
          <div :class="{active_d:(selectedSecond == '快乐工作')}" @click="gotoPoint('happyjob','快乐工作')">快乐工作</div>
          <div :class="{active_d:(selectedSecond == '联系我们')}" @click="gotoPoint('conactus','联系我们')">联系我们</div>
          <div :class="{active_d:(selectedSecond == '招聘信息')}" @click="gotoPoint('recruit','招聘信息')">招聘信息</div>
        </div>
      </div>
       
      
      <!--内容-->
      <div class="aboutus_body_box">
        <!--工作环境-->
        <div ref="workspace">
          <div class="about_wenhua_layout">
            <div class="web_title">工作环境</div>
            <div class="join_huanjing">
              <div class="join_text_layout">
                <div class="join_text_title">
                  <div class="title_l">北京</div>
                  <div class="title_r">BEIJING</div>
                </div>
                <div class="join_text_content">
                  <div class="title_2">金山软件大厦</div>
                  <div class="jtext">2009年，金山第一次搬到位于上地的大厦，一住就是十年，这里有很多金山人的回忆。这是一块福地，在这里金山成功完成移动互联网转型，走出了金山办公、金山云两家上市公司。2021年，大厦重新装修，旧貌换新颜。</div>
                  <div class="title_2">小米科技园</div>
                  <div class="jtext">小米科技园，8栋楼，34万平方米，造价52亿。其中D栋、E栋为金山软件办公楼。</div>
                </div>
              </div>
              <div class="join_lunbo_layout">
                <swiper  class="swiper gallery-top" :options="swiperOption" ref="swiperTop">
                  <swiper-slide>
                    <img src="../../../assets/img/joinus/beijing-1.jpg">
                  </swiper-slide>
                  <swiper-slide>
                    <img src="../../../assets/img/joinus/beijing-2.jpg">
                  </swiper-slide>
                  <swiper-slide>
                    <img src="../../../assets/img/joinus/beijing-3.jpg">
                  </swiper-slide>
                  <swiper-slide>
                    <img src="../../../assets/img/joinus/beijing-4.jpg">
                  </swiper-slide>
                  <div class="swiper-pagination" slot="pagination"></div>
                </swiper>
              </div>
            </div>
          </div>
          <div class="about_yewu_layout" >
            <div class="join_width">
              <div class="join_huanjing">
                <div class="join_lunbo_layout">
                  <swiper  class="swiper gallery-top" :options="swiperOption" ref="swiperTop">
                    <swiper-slide>
                      <img src="../../../assets/img/joinus/zhuhai-1.jpg">
                    </swiper-slide>
                    <swiper-slide>
                      <img src="../../../assets/img/joinus/zhuhai-2.jpg">
                    </swiper-slide>
                    <swiper-slide>
                      <img src="../../../assets/img/joinus/zhuhai-3.jpg">
                    </swiper-slide>
                    <swiper-slide>
                      <img src="../../../assets/img/joinus/zhuhai-4.jpg">
                    </swiper-slide>
                    <div class="swiper-pagination" slot="pagination"></div>
                  </swiper>
                </div>
                <div class="join_text_layout">
                  <div class="join_text_title">
                    <div class="title_l">珠海</div>
                    <div class="title_r">ZHUHAI</div>
                  </div>
                  <div class="join_text_content">
                    <div class="title_2">金山软件园</div>
                    <div class="jtext">
                      位于珠海高新区前岛环路329号，总占地面积约9.68万平方米，建筑面积超22.5万平方米，是一个集科技研发、文化创意、信息服务及数字艺术等业态的综合性园区。园区以“科创+艺术”为发展轴心，致力打造湾区创意聚集的活力平台，通过对上下游产业的梳理，构建多元开放、高频互动、聚合成长的良好生态。
                      <br><br>
                      园区建设有千人会议中心、创意交流绿地、创客美食市集、文旅艺术营地等地标，并引进行业顶级资源，打造科教互动、资讯互通、双创互联的新型成长空间，未来将会有超过一万名人才汇聚于此。
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="about_wenhua_layout" >
            <div class="join_huanjing">
              <div class="join_text_layout">
                <div class="join_text_title">
                  <div class="title_l">武汉</div>
                  <div class="title_r">WUHAN</div>
                </div>
                <div class="join_text_content">
                  <!--<div class="title_2">光谷中心</div>-->
                  <div class="jtext">金山拟在武汉投资40亿元，项目占地面积79,165㎡（约118亩），总建筑面积285115㎡。东侧紧临光谷四路，北侧靠近小米（武汉）地块，南部靠近南新街，西侧靠近金培路。<br><br>
                  新园区由德国GMP、香港PAL、杰恩、妙物等知名设计事务所参与设计，规划主要由办公楼、公寓楼、食堂楼三大主体区域构成，同时还设有商业、运动场等配套设施，最大可容纳员工9000人。
                  </div>
                </div>
              </div>
              <div class="join_lunbo_layout">
                <swiper  class="swiper gallery-top" :options="swiperOption" ref="swiperTop">
                  <swiper-slide>
                    <img src="../../../assets/img/joinus/wuhan-1.jpg">
                  </swiper-slide>
                  <swiper-slide>
                    <img src="../../../assets/img/joinus/wuhan-2.jpg">
                  </swiper-slide>
                  <swiper-slide>
                    <img src="../../../assets/img/joinus/wuhan-3.jpg">
                  </swiper-slide>
                  <swiper-slide>
                    <img src="../../../assets/img/joinus/wuhan-4.jpg">
                  </swiper-slide>
                  <div class="swiper-pagination" slot="pagination"></div>
                </swiper>
              </div>
            </div>
          </div>
        </div>
        
        <!--快乐工作-->
        <div class="about_yewu_layout" ref="happyjob">
          <div class="yewu_box">
            <div class="web_title">快乐工作</div>
            <div class="happy_work_layout">
              <div class="happy_list">
                <div class="happy_1">
                  <div class="happy_text">
                    <div class="happy_title">开园典礼</div>
                    <!-- <div class="happy_word">金山软件大厦举办开园庆典</div> -->
                  </div>
                  <div class="happy_mask"></div>
                  <img src="../../../assets/img/joinus/activity-1.png">
                </div>
                <div class="happy_2">
                  <div class="happy_text">
                    <div class="happy_title">1024程序员日</div>
                    <!-- <div class="happy_word">简介</div> -->
                  </div>
                  <div class="happy_mask"></div>
                  <img src="../../../assets/img/joinus/activity-4.jpg">
                </div>
              </div>
              <div class="happy_list">
                <div class="happy_2">
                  <div class="happy_text">
                    <div class="happy_title">主题生日会</div>
                    <!-- <div class="happy_word">简介</div> -->
                  </div>
                  <div class="happy_mask"></div>
                  <img src="../../../assets/img/joinus/activity-2.jpg">
                </div>
                <div class="happy_1">
                  <div class="happy_text">
                    <div class="happy_title">金山创想馆</div>
                    <!-- <div class="happy_word">简介</div> -->
                  </div>
                  <div class="happy_mask"></div>
                  <img src="../../../assets/img/joinus/activity-7.jpg">
                </div>
              </div>
              <div class="happy_list">
                <div class="happy_1">
                  <div class="happy_text">
                    <div class="happy_title">节日活动</div>
                    <!-- <div class="happy_word">简介</div> -->
                  </div>
                  <div class="happy_mask"></div>
                  <img src="../../../assets/img/joinus/activity-6.jpg">
                </div>
                <div class="happy_2">
                  <div class="happy_text">
                    <div class="happy_title">节日活动</div>
                    <!-- <div class="happy_word">简介</div> -->
                  </div>
                  <div class="happy_mask"></div>
                  <img src="../../../assets/img/joinus/activity-5.jpg">
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--联系我们-->
        <div class="about_wenhua_layout" ref="conactus">
          <div class="web_title">联系我们</div>
          <div class="contact_box">
            <div class="contact_list">
              <div class="contact_city">
                <i class="iconfont icon-website-dianhua"></i>
                <div>北京</div>
              </div>
              <div class="contact_tel">010-62927777</div>
            </div>
            <div class="contact_list">
              <div class="contact_city">
                <i class="iconfont icon-website-dianhua"></i>
                <div>珠海</div>
              </div>
              <div class="contact_tel">0756-3335688-2000</div>
            </div>
            <div class="contact_list">
              <div class="contact_city">
                <i class="iconfont icon-website-dianhua"></i>
                <div>武汉</div>
              </div>
              <div class="contact_tel">027-59503888</div>
            </div>
          </div>
        </div>

      </div>
    </main>
    <footer-build @gotoBody="gotoBody"></footer-build>
    
    
  </div>
</template>
<script>



import UtilEvent from '../utils/UtilEvent.js'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
  export default {
    name: 'joinUs',
    components:{UtilEvent,Swiper, SwiperSlide},
    props: {
      
    },
    created(){
        
    },
    data () {
      return {
        
        oldScrollTop:0,
        isShowTopTitle:true,
        showSecondTitle:false,
        lockSecondTop:false,
        topDivHeight:0,
        selectedSecond:'工作环境',
        swiperOption:{
            speed:1000,
            // spaceBetween: 10,
            autoplay:false,
            pagination: { el: '.swiper-pagination',clickable: true}
            
            // navigation: {
            //   nextEl: '.swiper-button-next',
            //   prevEl: '.swiper-button-prev'
            // },
        }
      }
    },
    computed:{
      
    },
    methods:{
      gotoBody(){
        this.$refs.parentDiv.scrollIntoView({
            behavior: "smooth",  // 平滑过渡
        });
      },
      gotoPoint(point,item){
        if(point == 'recruit'){
          let url = this.$router.resolve({
            name: 'recruit'
            
          });
          this.$PageUtil.openNewPage(this,url.href)
        }else{
          let offset = this.$refs[point].offsetTop;
          window.scrollTo({
              top:offset - 60,
              behavior: "smooth",  // 平滑过渡
          });
          setTimeout(()=>{
            this.selectedSecond = item;
          },900)
        }
        
      },
      scrolling(){
        //获取dom滚动距离
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop ||
                    document.body.scrollTop;
        if(scrollTop >= this.topDivHeight){
          this.lockSecondTop = true;
        }else{
          this.lockSecondTop = false;
        }
        let scrollStep = scrollTop - this.oldScrollTop;
        this.oldScrollTop = scrollTop;
        if(!this.lockSecondTop){
          //scrollTop <= this.topDivHeight - 64 此距离是为了避免点击页签时候页面向上时候会把第一个导航漏出来
          if (scrollStep < 0 && (scrollTop <= this.topDivHeight - 64)) {
              this.isShowTopTitle = true;
          } else {
            if(scrollStep > 10){
                this.isShowTopTitle = false;
              }
          }
        }else{
          this.isShowTopTitle = false;
          this.handlerDivsListener();
        }
        
      },
      clickSecondHandler(name){
        
        this.$refs.secondNav.scrollIntoView({
            behavior: "smooth",  // 平滑过渡
        });
      },
      handlerDivsListener(){
        let arrayName = ["工作环境","快乐工作","联系我们"];
        let array = ["workspace","happyjob","conactus"];
        let prePos = Math.abs(this.$refs[array[0]].getBoundingClientRect().top);
        this.selectedSecond = arrayName[0];
        for(let i = 1;i < array.length;i++ ){
          let temp = this.$refs[array[i]].getBoundingClientRect().top
          let offsetTop = Math.abs(temp);
          if((temp - 58 <= 0) && (offsetTop < prePos)){
            prePos = offsetTop;
            this.selectedSecond = arrayName[i];
          }
        }
        
      },
      
    },
    watch:{
      
    },
    mounted(){
      //获得头部div高度
      this.topDivHeight = this.$refs.topDiv.offsetHeight;
      //刚加载页面后会有偏移量，便宜后再去监听
      setTimeout(()=>{
        window.addEventListener("scroll", this.scrolling)
      },300)
    },
    destroyed() {
      window.removeEventListener("scroll", this.scrolling);
    },
  }
  </script>

